"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkdownContainer = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const MarkdownContainer = exports.MarkdownContainer = /*#__PURE__*/(0, _base.default)('div', process.env.NODE_ENV === "production" ? {
  target: "e1pupn8m0"
} : {
  target: "e1pupn8m0",
  label: "MarkdownContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "r9bg39",
  styles: "display:flex;flex-direction:column;p{margin:0;}"
} : {
  name: "r9bg39",
  styles: "display:flex;flex-direction:column;p{margin:0;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01hcmtkb3duL3N0eWxlcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFOEMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTWFya2Rvd24vc3R5bGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5leHBvcnQgY29uc3QgTWFya2Rvd25Db250YWluZXIgPSBzdHlsZWQoJ2RpdicpYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBwIHtcbiAgICBtYXJnaW46IDA7XG4gIH1cbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});